module.exports = __webpack_public_path__ + "img/step21_b_printer_basic_remove_retainers_close_roll_cover.2febf1f4.png";